import React from "react";
import { LucideIcon } from "lucide-react";

export interface StatItem {
  icon: LucideIcon;
  value: string;
  label: string;
  sub?: string;
  accent?: boolean;
}

interface StatBarProps {
  items: StatItem[];
}

export const StatBar: React.FC<StatBarProps> = ({ items }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-[0_12px_35px_-24px_rgba(15,23,42,0.35)] sm:px-7">
      <div className="grid grid-cols-2 gap-y-5 md:grid-cols-4 md:gap-y-0">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <div
              key={i}
              className="flex items-center gap-3 md:border-r md:border-slate-200 md:px-6 md:first:pl-0 md:last:border-r-0 md:last:pr-0"
              data-testid={`stat-${i}`}
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600 shadow-sm">
                <Icon className="h-5 w-5" strokeWidth={2.2} />
              </span>
              <div className="leading-tight">
                <div
                  className={`text-lg font-extrabold ${
                    it.accent ? "text-red-600" : "text-slate-950"
                  }`}
                >
                  {it.value}
                </div>
                <div className="text-sm font-semibold text-slate-800">{it.label}</div>
                {it.sub && <div className="text-xs text-slate-500">{it.sub}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatBar;
